import React from 'react';
import { Link } from 'react-router-dom';
import { useLocalePath } from '../context/LocaleContext';

/**
 * Link component that automatically prepends the locale prefix (/cn) when locale is zh-CN.
 * Use this for all internal navigation to keep URLs in sync with the selected locale.
 */
const LocaleLink = ({ to, children, ...props }) => {
  const localeTo = useLocalePath(to);
  return (
    <Link to={localeTo} {...props}>
      {children}
    </Link>
  );
};

export default LocaleLink;
